import { render, staticRenderFns } from "./TaskDeliveryView.vue?vue&type=template&id=5da53654&scoped=true&"
import script from "./TaskDeliveryView.vue?vue&type=script&lang=js&"
export * from "./TaskDeliveryView.vue?vue&type=script&lang=js&"
import style0 from "./TaskDeliveryView.vue?vue&type=style&index=0&id=5da53654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da53654",
  null
  
)

export default component.exports